export class ResponseError extends Error {
  constructor(message) {
    super(message);
  }
}